import { render, staticRenderFns } from "./Suppliers.html?vue&type=template&id=6a1a45a8&external"
import script from "./Suppliers.js?vue&type=script&lang=js&external"
export * from "./Suppliers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports